import { DirectReportsType, EmploymentTypes, WorkArrangements, WorkExperienceType } from '@talentmesh/utils';
import { JobPostingType } from './JobPostingType';
import { DefaultLocationDetailsDTO, LocationDetailsDTO } from './LocationDetailsDTO';
import { defaultLanguage } from '@/Utils/JobAdLanguage/JobAdLanguages';

export interface JobDetailsDTO {
    name: string;
    workArrangement: WorkArrangements;
    locationDetails: LocationDetailsDTO;
    jobFunctionId: number;
    workExperience: WorkExperienceType;
    employmentType: EmploymentTypes;
    directReports: DirectReportsType;
    yearlySalaryFrom: number | null;
    yearlySalaryTo: number | null;
    currency: string | null;
    jobDescriptionLanguage: string;
    jobPostingType: JobPostingType;
}

export const DefaultJobDetailsDTO: JobDetailsDTO = {
    directReports: 'None',
    workArrangement: 'OnLocation',
    jobFunctionId: 0,
    name: '',
    workExperience: 'GraduateOrAnalyst',
    employmentType: 'FullTime',
    locationDetails: DefaultLocationDetailsDTO,
    yearlySalaryFrom: null,
    yearlySalaryTo: null,
    currency: null,
    jobDescriptionLanguage: defaultLanguage.label,
    jobPostingType: 'Direct',
};

export interface JobAdDetailsDTO extends JobDetailsDTO {
    jobFunctionName: string;
    jobCategoryName: string;
}

export const DefaultJobAdDetailsDTO: JobAdDetailsDTO = {
    ...DefaultJobDetailsDTO,
    jobFunctionName: '',
    jobCategoryName: '',
};
